import { Component, computed, input, Input } from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-progress',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './progress.component.html',
  styleUrl: './progress.component.scss'
})
export class ProgressComponent {
  public progress = input.required<number>();
  public type = input.required<ProgressType>();
  protected _progress= computed(() => Math.min(Math.max(0, this.progress()), 100));
}

export type ProgressType = 'linear' | 'circular';
